import { render, staticRenderFns } from "./MessageBodyNodeYoutubePlayer.vue?vue&type=template&id=66e191c0&lang=pug&"
import script from "./MessageBodyNodeYoutubePlayer.vue?vue&type=script&lang=js&"
export * from "./MessageBodyNodeYoutubePlayer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "MessageBodyNodeYoutubePlayer.vue"
export default component.exports